import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  addBranch,
  addDesignation,
  addOrgUnit,
  addOutletTypes,
  addOutletTypesModules,
  getBranchList,
  getCountryList,
  getDesignationColorsList,
  getDesignationList,
  getOrgUitList,
  getOutletTypeList,
  getOutletTypeModuleList,
  getUserConfig,
  update_OrgUnit,
  updateBranch,
  updateDesignation,
  updateOutletType,
  updateOutletTypeModule,
} from "./SettingsMastersRepo";
import { showToast } from "../../../../utils/toastUtils";
// import { addBranch, updateBranch } from "../../hook/SettingRepo";

interface ReqBodyInterface {
  UnitName: string;
  CurrencyId: number;
  Icountryid: number;
  CanDoCustomPlaylist: number;
  IsExposed:number;
  OrgunitAdminPosition: number;
  PunchinOnWeekoff: number;
  PunchinOnHoliday: number;
  PunchinOnLeave: number;
  // EmployeeId: number[];
  EmployeeId:null;
}

export const useGetOrgList = ({
  enable = false,
  params,
}:{
  enable: boolean;
  params: any;
}) => {
  return useQuery({
    queryKey: ["GET_ORG_LIST", params],
    queryFn: () => getOrgUitList(params),
    enabled: enable,
    retry: false,
  });
};

export const useGetCountryList = ({ enable = false }: { enable: boolean }) => {
  return useQuery({
    queryKey: ["GET_COUNTRY_LIST"],
    queryFn: getCountryList,
    enabled: enable,
    retry: false,
  });
};

export const useAddOrgUnit = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (ReqBody: ReqBodyInterface) => addOrgUnit(ReqBody),
    onSuccess: () => {
      showToast.success("Org add Successfully");
      queryClient.invalidateQueries({ queryKey: ["GET_ORG_LIST"] });
    },
    onError: (error: any) => {
      console.log(`Falied to add Org Unit ${error.message}`);
      showToast.error("Failed to add Org unit");
    },
  });
};


export const useUpdateOrgUnit = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ReqBody,id}:{ReqBody: ReqBodyInterface,id:number}) =>update_OrgUnit(ReqBody,id),
    onSuccess: () => {
      showToast.success("Update add Successfully");
      queryClient.invalidateQueries({ queryKey: ["GET_ORG_LIST"] });
    },
    onError: (error: any) => {
      console.log(`Falied to add Upadate Unit ${error.message}`);
      showToast.error("Failed to add Update unit");
    },
  });
};





export const useGetUserConfig = ({ enable = false }) => {
  return useQuery({
    queryKey: ["GET_USER_CONFIG"],
    queryFn: getUserConfig,
    enabled: enable,
    retry: false,
  });
};

// getBranchList

export const useGetBranchList = ({
  enable = false,
  params,
}: {
  enable: boolean;
  params?: string | number | any;
}) => {
  return useQuery({
    queryKey: ["GET_BRANCH_LIST", params],
    queryFn: () => getBranchList(params),
    enabled: enable,
    retry: false,
  });
};

// addBranch
export const useAddBranch = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: any) => addBranch(body),
    onSuccess: () => {
      showToast.success("Branch added Successfully");
      queryClient.invalidateQueries({ queryKey: ["GET_BRANCH_LIST"] });
    },
    onError: (error: any) => {
      console.log(`Failed to add Branch ${error.message}`);
      showToast.error("Failed to add Branch");
    },
  });
};

// updateBranch

export const useUpdateBranch = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id?: string | number; body: any }) =>
      updateBranch(id, body),
    onSuccess: () => {
      showToast.success("Branch Updated Successfully");
      queryClient.invalidateQueries({ queryKey: ["GET_BRANCH_LIST"] });
    },
    onError: (error: any) => {
      console.log(`Failed to Update Branch ${error.message}`);
      showToast.error("Failed to Update Branch");
    },
  });
};

export const useGetDesignation = ({
  enable = false,
  params,
}: {
  enable?: boolean;
  params?: string | any;
}) => {
  return useQuery({
    queryKey: ["GET_DESIGNATION", params],
    queryFn: () => getDesignationList(params),
    enabled: enable,
    retry: false,
  });
};

export const useGetDesignationColors = ({
  enable = false,
}: {
  enable?: boolean;
}) => {
  return useQuery({
    queryKey: ["GET_DESIGNATION_COLOR"],
    queryFn: getDesignationColorsList,
    enabled: enable,
    retry: false,
  });
};

// addDesignation
export const useAddDesignation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: {
      designationName: string | number;
      designationColor: string | number;
    }) => addDesignation(body),
    onSuccess: () => {
      showToast.success("Add Designation Successfully!");
      queryClient.invalidateQueries({ queryKey: ["GET_DESIGNATION"] });
    },
    onError: (error: any) => {
      console.log(`Failed to add Designation ${error.message}`);
      showToast.warning("Failed to Add Designation!");
    },
  });
};

// updateDesignation
export const useUpdateDesignation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ body }: { body: any }) => updateDesignation(body),
    onSuccess: () => {
      showToast.success("Update Designation Successfully!");
      queryClient.invalidateQueries({ queryKey: ["GET_DESIGNATION"] });
    },
    onError: (error: any) => {
      console.log(`Failed to Update Designation ${error.message}`);
      showToast.warning("Failed to Update Designation!");
    },
  });
};

// getOutletTypeList
export const useOutletTypeList = ({ enable = false }: { enable?: boolean }) => {
  return useQuery({
    queryKey: ["GET_OUTLET_TYPE_LIST"],
    queryFn: getOutletTypeList,
    enabled: enable,
    retry: false,
  });
};

// addOutletTypes
export const useAddOutletTypes = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body?: any) => addOutletTypes(body),
    onSuccess: () => {
      showToast.success("Add Outlet Type Successfully!");
      queryClient.invalidateQueries({ queryKey: ["GET_OUTLET_TYPE_LIST"] });
    },
    onError: (error: any) => {
      console.log(`Failed to add Outlet Type ${error.message}`);
      showToast.warning("Failed to Add Outlet Type!");
    },
  });
};

// updateOutletType
export const useUpdateOutletType = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, body }: { id?: string | number; body?: any }) =>
      updateOutletType(id, body),
    onSuccess: () => {
      showToast.success("Update Outlet Type Successfully!");
      queryClient.invalidateQueries({ queryKey: ["GET_OUTLET_TYPE_LIST"] });
    },
    onError: (error: any) => {
      console.log(`Failed to Update Outlet Type ${error.message}`);
      showToast.warning("Failed to Update Outlet Type!");
    },
  });
};

// getOutletTypeModuleList
export const useOutletTypeModuleList = ({
  id,
  params,
  enable = false,
}: {
  id?: string | number;
  params?: any;
  enable?: boolean;
}) => {
  return useQuery({
    queryKey: ["GET_OUTLET_TYPE_MODULE_LIST", params],
    queryFn: () => getOutletTypeModuleList(id, params),
    enabled: enable,
    retry: false,
  });
};

// addOutletTypesModules

export const useAddOutletTypesModule = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body?: any) => addOutletTypesModules(body),
    onSuccess: () => {
      showToast.success("Add Outlet Type Module Successfully!");
      queryClient.invalidateQueries({
        queryKey: ["GET_OUTLET_TYPE_MODULE_LIST"],
      });
    },
    onError: (error: any) => {
      console.log(`Failed to add Outlet Type Module ${error.message}`);
      showToast.warning("Failed to Add Outlet Type Module!");
    },
  });
};

// updateOutletTypeModule

export const useUpdateOutletTypeModule = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, body }: { id?: string | number; body?: any }) =>
      updateOutletTypeModule(id, body),
    onSuccess: () => {
      showToast.success("Update Outlet Type Module Successfully!");
      queryClient.invalidateQueries({
        queryKey: ["GET_OUTLET_TYPE_MODULE_LIST"],
      });
    },
    onError: (error: any) => {
      console.log(`Failed to Update Outlet Type Module ${error.message}`);
      showToast.warning("Failed to Update Outlet Type Module!");
    },
  });
};
